import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { UI_KENDO } from '@maximizer/core/shared/ui/kendo';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { EmailDraft } from '../../models/action-card.model';

@Component({
  selector: 'maximizer-email-draft-editor',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, KENDO_INPUTS, UI_KENDO, UI_PIPES],
  templateUrl: './email-draft-editor.component.html',
})
export class EmailDraftEditorComponent {
  readonly draft = input.required<EmailDraft>();
  readonly canEditSubject = input(false);
  readonly canEditBody = input(false);
  readonly rows = input(9);
  readonly showAvatar = input(false);

  readonly subjectChange = output<string>();
  readonly bodyChange = output<string>();
}
